import {
  ApplicationLocalizationDto,
  ApplicationLocalizationRequestDto,
  Rest,
  RestService,
} from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable, from, map, tap } from 'rxjs';
import { LocalConfigurationType } from '../local-db/objects/local-configuration';
import { LocalConfigurationRepository } from '../local-db/repositories/local-configuration-repository';
import { LocalStorageConsts } from '../AppConsts';

@Injectable({
  providedIn: 'root',
})
export class CustomApplicationLocalizationService {
  private readonly apiName = 'abp';

  constructor(
    private readonly _localConfigurationRepository: LocalConfigurationRepository,
    private readonly _restService: RestService
  ) {}

  get: (
    options: ApplicationLocalizationRequestDto,
    config?: Partial<Rest.Config>
  ) => Observable<ApplicationLocalizationDto> = (options, config) => {
      const instance = this as CustomApplicationLocalizationService;
      const user = JSON.parse(localStorage.getItem(LocalStorageConsts.CurrentUserKey));

      if (window.navigator.onLine) {
        return instance._restService
          .request<any, ApplicationLocalizationDto>(
            {
              method: 'GET',
              url: '/api/abp/application-localization',
              params: {
                cultureName: options?.cultureName,
                onlyDynamics: options?.onlyDynamics,
              },
            },
            { apiName: instance.apiName, ...config }
          )
          .pipe(
            tap(response =>
              instance._localConfigurationRepository.set(
                user?.id ?? '',
                LocalConfigurationType.ApplicationLocalization,
                response
              )
            )
          );
      } else {
        return from(
          instance._localConfigurationRepository.get(
            user?.id ?? '',
            LocalConfigurationType.ApplicationLocalization
          )
        ).pipe(map(response => response?.data as ApplicationLocalizationDto));
      }
    };
}
